<template>
    <div class="myfeed" @click="clickAction">
        <div><img :src="require('@/assets/' + icon)" style="width:15px;"></div>
        <div style="flex:1;"  class="myfeed_txt">{{label}}</div>
        <div v-if="count > 0" style="background-color:#ff6100; width:22px; height:22px; border-radius:11px; display:grid; place-items: center; color:white;">{{count}}</div>
        <div v-if="!isArrowHidden" style="font-size:0px;"><img :src="require('@/assets/search_back.png')" style="width:8px; transform: rotate(180deg); margin-left:15px;"></div>
    </div>
</template>

<script>
    export default {
        name: "MyFeedLabel",
        props :{
            icon : {
                type : String,
                default : '',
            },
            clickAction : {
                type : Function,
                default : () => {}
            },
            count : {
                type : Number,
                default : 0
            },
            label : {
                type : String,
                default : ''
            },
            isArrowHidden : {
                type : Boolean,
                default : false
            }
        },
    }
</script>

<style scoped>

    .myfeed{
        display:flex;
        padding:0px 20px;
        box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.11);
        align-items: center;
        border-radius:20px;
        height:38px;
        background-color: white;
    }
    .myfeed_txt{font-size:15px; padding-left:20px;}
</style>